import type { User } from '@configcat/sdk';
import { useFeatureFlag } from 'configcat-react';

import { PRODUCTS_IN_MAINTENANCE_MODE } from '../toggles';

export const useProductInMaintenanceMode = (productId: string | undefined, productLevel?: string) => {
    const sku = productId?.trim().toUpperCase();
    const level = productLevel?.trim().toUpperCase();

    const custom: Record<string, string> = {
        ...(sku && { sku }),
        ...(sku && level && { level }),
    };

    const user: User | undefined = sku ? { identifier: `app-${sku}`, custom } : undefined;
    const { value: isMaintenanceEnabled } = useFeatureFlag<boolean>(PRODUCTS_IN_MAINTENANCE_MODE, false, user);
    return Boolean(isMaintenanceEnabled);
};
